<div class="water-log-wrapper">
  <div class="target-row">
    <div class="current-target-box">
      <span class="target-label">Current Target: </span><span class="target-value">{{ currentTargetGlasses }} glasses / {{ currentTargetQuantity }} {{ currentTargetUnit }}</span>
    </div>

    <div class="custom-target-group">
      <div class="custom-target-box">
        <span class="custom-target-label">Custom Target:</span>
        <button type="button" class="target-step-btn" (click)="decrementCustomTarget()" aria-label="Decrease custom target">&minus;</button>
        <span class="custom-target-value">{{ customTargetValue }}</span>
        <button type="button" class="target-step-btn" (click)="incrementCustomTarget()" aria-label="Increase custom target">+</button>
        <span class="custom-target-unit">{{ customTargetUnit }}</span>
        <span class="unit-toggle">
          <button type="button" class="unit-arrow-btn" (click)="setUnit('ml')" aria-label="Switch unit to ml">&#9650;</button>
          <button type="button" class="unit-arrow-btn" (click)="setUnit('fl oz')" aria-label="Switch unit to fl oz">&#9660;</button>
        </span>
      </div>
      <button type="button" class="add-target-btn" [disabled]="customTargetValue === 0" (click)="onAddCustomTarget()">Add</button>
      <button type="button" class="delete-target-btn" *ngIf="customTargetValue > 0" (click)="resetCustomTarget()">Delete</button>
    </div>
  </div>

  <div class="calendar-header">
    <div class="event-nav-row">
      <div class="month-nav-group">
        <button class="nav-circle-btn"
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="onMonthNavChange()">
          <span class="nav-arrow">&#8249;</span>
        </button>
        <span class="month-nav-label">{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</span>
        <button class="nav-circle-btn"
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="onMonthNavChange()">
          <span class="nav-arrow">&#8250;</span>
        </button>
      </div>
      <select class="year-pill-select" [(ngModel)]="selectedYear" (ngModelChange)="onYearChange($event)">
        <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
      </select>
    </div>
  </div>

  <ng-template #customCellTemplate let-day="day" let-locale="locale">
    <div class="cal-cell-top">
      <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
    </div>
    <div class="water-log-cell-badge" *ngIf="day.inMonth">
      <ng-container *ngIf="getGlassCount(day.date) > 0; else noWaterLog">
        <img src="/assets/img/memberdashboard/waterLogPersent.png" class="water-log-icon" alt="Water logged" />
        <span class="water-log-count">{{ getGlassCount(day.date) }} Glasses</span>
      </ng-container>
      <ng-template #noWaterLog>
        <img src="/assets/img/memberdashboard/wateLogAbsent.png" class="water-log-icon" alt="No water logged" />
      </ng-template>
    </div>
  </ng-template>

  <div [ngSwitch]="view">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [cellTemplate]="customCellTemplate"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day)">
    </mwl-calendar-month-view>
  </div>

  <div class="wl-modal-backdrop" *ngIf="showWaterLogModal" (click)="closeWaterLogModal()">
    <div class="wl-modal" (click)="$event.stopPropagation()">
      <div class="wl-modal-header">
        <button type="button" class="wl-modal-close" (click)="closeWaterLogModal()" aria-label="Close">&#10005;</button>
      </div>
      <div class="wl-modal-body">
        <h4 class="wl-modal-title">Water Log</h4>
        <p class="wl-modal-date">{{ selectedDayDate | date:'EEEE, MMMM d, y' }}</p>

        <ng-container *ngIf="hasGoalForDate; else noGoalForDate">
          <div class="wl-drops-row">
            <img *ngFor="let d of filledDrops" src="/assets/img/memberdashboard/waterLogPersent.png" class="wl-drop-icon" alt="Logged" />
            <img *ngFor="let d of remainingDrops" src="/assets/img/memberdashboard/wateLogAbsent.png" class="wl-drop-icon" alt="Remaining" />
          </div>
          <p class="wl-drops-caption" [class.wl-drops-caption-disabled]="isFutureSelectedDate" (click)="onAddWaterLog()">Click here to add water log</p>

          <div class="wl-summary-row">
            <span>{{ padNumber(selectedDateCount) }} / {{ padNumber(selectedDateGoalGlasses) }} Glasses</span>
            <span class="wl-summary-divider"></span>
            <span>{{ selectedDateQuantity }} / {{ selectedDateGoalQuantity }} {{ selectedDateGoalUnit }}</span>
          </div>

          <p class="wl-goal-hit-message" *ngIf="selectedDateGoalGlasses > 0 && selectedDateCount >= selectedDateGoalGlasses">You hit your hydration goal for today. Nicely done!</p>

          <button type="button" class="wl-view-logs-btn" (click)="toggleAllLogs()">
            {{ showAllLogs ? 'Close Logs' : 'View All Logs' }}
          </button>

          <div class="wl-logs-table" *ngIf="showAllLogs">
            <ng-container *ngIf="selectedDateLogs.length > 0; else noLogsForDate">
              <div class="wl-log-row" *ngFor="let log of selectedDateLogs; let i = index">
                <span class="wl-log-sno">{{ padNumber(i + 1) }}.</span>
                <span class="wl-log-label">Water Log {{ i + 1 }}</span>
                <span class="wl-log-time">{{ log.loggedAt | date:'hh:mm a' }}</span>
                <span class="wl-log-qty">{{ perLogQuantity }} {{ selectedDateGoalUnit }}</span>
                <button type="button" class="wl-log-delete-btn" (click)="onDeleteWaterLog(log)" aria-label="Delete water log">
                  <img src="/assets/img/mealPlanDelete.png" class="wl-log-delete-icon" alt="Delete" />
                </button>
              </div>
            </ng-container>
            <ng-template #noLogsForDate>
              <p class="wl-empty-message">There are no logs for this date.</p>
            </ng-template>
          </div>
        </ng-container>

        <ng-template #noGoalForDate>
          <p class="wl-empty-message">There are no water logs for this date.</p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
